import { useState } from 'react';

import { LinkPL } from '../../edit-link/styles';
import {
	HeaderStep,
	LinkCopyPasteContainer,
	QRCodeImgContainer,
	QRContainer,
	QRContainerData,
	QRSubtitle,
	QRSubtitleBottom,
	QRTitle,
	TabBody,
	TitleStep,
} from '../styles';
import { CircleStepThree } from './icons';

interface QRTabProps {
	amount: string;
	id: string;
	merchantName: string;
	paymentLinkName: string;
	paymentLinkUrl: string;
	paymentLinkUrlQR: string;
}

const QRTabPL = ({
	amount,
	id,
	merchantName,
	paymentLinkName,
	paymentLinkUrl,
	paymentLinkUrlQR,
}: QRTabProps) => {
	const [copied, setCopied] = useState('Copiar');
	const urlArray = paymentLinkUrl.split('//');

	const _copyCliboard = async () => {
		await navigator.clipboard.writeText(paymentLinkUrl);
		setCopied('Copiado');
		setTimeout(() => setCopied('Copiar'), 2500);
	};

	return (
		<TabBody id={id}>
			<HeaderStep>
				<CircleStepThree /> <TitleStep>Comparte para recibir cobros</TitleStep>
			</HeaderStep>
			<LinkCopyPasteContainer>
				<small>Enlace de cobro</small>
				<QRContainerData>
					<LinkPL href={paymentLinkUrl} target="_blank" rel="noopener noreferrer">
						{urlArray[1]}
					</LinkPL>
					<button type="button" onClick={_copyCliboard}>
						{copied}
					</button>
				</QRContainerData>
			</LinkCopyPasteContainer>

			<QRContainer>
				<QRTitle>Pagar ${amount}</QRTitle>
				<QRSubtitle>{paymentLinkName}</QRSubtitle>
				<QRCodeImgContainer>
					<img src={paymentLinkUrlQR} alt="QR del pago" />
				</QRCodeImgContainer>
				<QRSubtitleBottom>
					Escanea el código <br /> para pagar a {merchantName}
				</QRSubtitleBottom>
			</QRContainer>
		</TabBody>
	);
};

export { QRTabPL };
